import React, { useState } from "react";
import { ABOUT_PAGE } from "../../data/constants";
import chevronRed from "../../assets/chev-lrs.svg";
import chevronDefault from "../../assets/chev-lrs.png";
const values = ABOUT_PAGE.ourValues.values;

const OurValuesSection: React.FC = () => {
  const [activeId, setActiveId] = useState<number | null>(null);
  const toggle = (id: number) => setActiveId(activeId === id ? null : id);

  return (
    <section className="bg-[#F5F7FA] py-[64px] md:py-[120px] px-[16px] sm:px-6 md:px-20">
      <h2 className="font-utility font-medium text-[30px]  md:text-[54px] leading-tight text-[#011621] mb-8 md:mb-12">
        {ABOUT_PAGE.ourValues.title}
      </h2>

      <div className="divide-y-2 divide-gray-300">
        {values.map((item) => {
          const isOpen = activeId === item.id;
          return (
            <div key={item.id} className="md:py-6 pt-4 pb-4 md:pb-10">
              {/* Header */}
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between"
              >
                <div className="flex flex-wrap items-center gap-6 sm:gap-[150px]">
                  <span className="font-inter font-semibold text-base sm:text-[22px] text-[#011621] w-8">
                    {String(item.id).padStart(2, "0")}
                  </span>
                  <h3 className="font-utility text-[16px]  md:text-[36px] font-medium text-[#011621]">
                    {item.title}
                  </h3>
                </div>

                 <img
    src={isOpen ? chevronRed : chevronDefault}
    alt="chevron"
    className={`
      transition-transform duration-300
      ${isOpen ? "rotate-180" : "rotate-0"}
      w-5 h-5 sm:w-12 sm:h-12
    `}
  />
              </button>

              {/* Sliding body */}
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  isOpen ? "max-h-[600px] mt-6" : "max-h-0 mt-0"
                }`}
              >
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-[32px] mt-4 ml-[56px] md:ml-[186px]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-[288px] h-[163px] sm:w-[405px] sm:h-[221px] object-cover"
                  />
                  <p className="font-inter text-[14px] md:text-[20px] leading-[1.6] text-[#033652]">
                    {item.content}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OurValuesSection;
